var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mainAuxPage zj-flex-column" },
    [
      _c("div", { staticClass: "zj-flex-row" }, [
        _c(
          "div",
          {
            staticStyle: {
              border: "1.5px solid rgb(221 221 221)",
              display: "flex",
              flex: "1",
              "margin-right": "7px",
              "box-shadow": "0 0 3px rgba(188,  186,  186,  0.8)",
            },
          },
          [
            _c("div", { staticClass: "zj-flex-column" }, [
              _c(
                "div",
                {
                  staticClass: "zj-tbar",
                  staticStyle: {
                    "margin-bottom": "0",
                    "background-color": "#e5e5e5",
                    "border-bottom": "3px solid rgb(221 221 221)",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "zj-flex-row",
                      staticStyle: {
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "margin-right": "10px",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-more",
                              title: "更多",
                              size: "mini",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.gotoLecture()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-refresh",
                              title: "刷新",
                              size: "mini",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.refreshLectureData(1)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "5px 30px",
                    display: "flex",
                    flex: "1",
                    "background-color": "white",
                  },
                },
                [
                  _c(
                    "zj-table",
                    {
                      ref: "lectureTable",
                      attrs: {
                        data: _vm.lectureData,
                        "show-header": false,
                        border: false,
                        "highlight-current-row": false,
                        "row-style": { height: "40px", color: "#8d9196" },
                      },
                      on: { "row-click": _vm.openLectureDetail },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { width: "40" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "zj-flex-right" }, [
                                  (new Date().getTime() -
                                    new Date(scope.row.start_time).getTime()) /
                                    (1000 * 3600 * 24) <
                                  7
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "right",
                                            "margin-right": "10px",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "25px",
                                              height: "25px",
                                            },
                                            attrs: {
                                              src: "/static/base/img/huo.png",
                                            },
                                          }),
                                        ]
                                      )
                                    : (new Date(scope.row.end_time).getTime() -
                                        new Date().getTime()) /
                                        (1000 * 3600 * 24) <
                                      2
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "right",
                                            "margin-right": "10px",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "25px",
                                              height: "25px",
                                            },
                                            attrs: {
                                              src: "/static/base/img/已结束.png",
                                            },
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "right",
                                            "margin-right": "10px",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "25px",
                                              height: "25px",
                                            },
                                            attrs: {
                                              src: "/static/base/img/competition.png",
                                            },
                                          }),
                                        ]
                                      ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "emp_researchfiled",
                          label: "研究领域",
                          align: "left",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "custom-link" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "zj-flex-row",
                                      staticStyle: {
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            flex: "1",
                                            "flex-direction": "row",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(scope.row.pi_sponsor) +
                                              _vm._s(
                                                "-【" +
                                                  scope.row.pi_title +
                                                  "】"
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                      报名时间:" +
                                            _vm._s(
                                              _vm._f("dateFilter")(
                                                scope.row.start_time,
                                                "yyyy/MM/dd"
                                              )
                                            ) +
                                            "~" +
                                            _vm._s(
                                              _vm._f("dateFilter")(
                                                scope.row.end_time,
                                                "yyyy/MM/dd"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", { attrs: { width: "-1" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              border: "1.5px solid rgb(221 221 221)",
              display: "flex",
              flex: "1",
              "margin-left": "7px",
              "box-shadow": "0 0 3px rgba(188,  186,  186,  0.8)",
            },
          },
          [
            _c("div", { staticClass: "zj-flex-column" }, [
              _c(
                "div",
                {
                  staticClass: "zj-tbar",
                  staticStyle: {
                    "margin-bottom": "0",
                    "background-color": "#e5e5e5",
                    "border-bottom": "3px solid rgb(221 221 221)",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "zj-flex-row",
                      staticStyle: {
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "margin-right": "10px",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-more",
                              title: "更多",
                              size: "mini",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.gotoCourse()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-refresh",
                              title: "刷新",
                              size: "mini",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.refreshLectureData(2)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "5px 30px",
                    display: "flex",
                    flex: "1",
                    "background-color": "white",
                  },
                },
                [
                  _c(
                    "zj-table",
                    {
                      ref: "courseTable",
                      attrs: {
                        data: _vm.courseData,
                        "show-header": false,
                        border: false,
                        "highlight-current-row": false,
                        "row-style": { height: "40px", color: "#8d9196" },
                      },
                      on: { "row-click": _vm.openLectureDetail },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { width: "40" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "zj-flex-right" }, [
                                  (new Date().getTime() -
                                    new Date(scope.row.start_time).getTime()) /
                                    (1000 * 3600 * 24) <
                                  7
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "right",
                                            "margin-right": "10px",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "25px",
                                              height: "25px",
                                            },
                                            attrs: {
                                              src: "/static/base/img/huo.png",
                                            },
                                          }),
                                        ]
                                      )
                                    : (new Date(scope.row.end_time).getTime() -
                                        new Date().getTime()) /
                                        (1000 * 3600 * 24) <
                                      2
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "right",
                                            "margin-right": "10px",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "25px",
                                              height: "25px",
                                            },
                                            attrs: {
                                              src: "/static/base/img/已结束.png",
                                            },
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "right",
                                            "margin-right": "10px",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "25px",
                                              height: "25px",
                                            },
                                            attrs: {
                                              src: "/static/base/img/competition.png",
                                            },
                                          }),
                                        ]
                                      ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "emp_researchfiled",
                          label: "研究领域",
                          align: "left",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "custom-link" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "zj-flex-row",
                                      staticStyle: {
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            flex: "1",
                                            "flex-direction": "row",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(scope.row.pi_sponsor) +
                                              _vm._s(
                                                "-【" +
                                                  scope.row.pi_title +
                                                  "】"
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                      报名时间:" +
                                            _vm._s(
                                              _vm._f("dateFilter")(
                                                scope.row.start_time,
                                                "yyyy/MM/dd"
                                              )
                                            ) +
                                            "~" +
                                            _vm._s(
                                              _vm._f("dateFilter")(
                                                scope.row.end_time,
                                                "yyyy/MM/dd"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", { attrs: { width: "-1" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "800px",
            title: "大赛详情",
            visible: _vm.showLectureDetail,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showLectureDetail = $event
            },
          },
        },
        [
          _c(
            "zj-form",
            {
              ref: "lectureForm",
              attrs: { model: _vm.lectureContent, "label-width": "150px" },
            },
            [
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "名称:", prop: "pi_title" },
                    },
                    [_vm._v(_vm._s(_vm.lectureContent.pi_title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "主办单位:", prop: "pi_sponsor" },
                    },
                    [_vm._v(_vm._s(_vm.lectureContent.pi_sponsor))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "报名开始时间:", prop: "start_time" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFilter")(
                            _vm.lectureContent.start_time,
                            "yyyy-MM-dd HH:mm"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "报名结束时间:", prop: "end_time" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFilter")(
                            _vm.lectureContent.end_time,
                            "yyyy-MM-dd HH:mm"
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "650px" },
                      attrs: { label: "介绍:", prop: "pi_content" },
                    },
                    [
                      [
                        _c("div", { staticClass: "right_editor" }, [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.lectureContent.pi_content),
                            },
                          }),
                        ]),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "800px",
            title: "课程详情",
            visible: _vm.showCourseDetail,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCourseDetail = $event
            },
          },
        },
        [
          _c(
            "zj-form",
            {
              ref: "courseForm",
              attrs: { model: _vm.courseContent, "label-width": "150px" },
            },
            [
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "课程名称：", prop: "p_name" },
                    },
                    [_vm._v(_vm._s(_vm.courseContent.p_name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: { label: "讲师：", prop: "emp_name" },
                    },
                    [_vm._v(_vm._s(_vm.courseContent.emp_name))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "740px" },
                      attrs: { label: "课程说明：", prop: "p_note" },
                    },
                    [
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              flex: "1",
                              "flex-direction": "row",
                              "flex-flow": "wrap",
                              "letter-spacing": "0.1em",
                              "line-height": "18px",
                              "align-items": "center",
                              "min-height": "40px",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.courseContent.p_note) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-form" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: {
                        label: "报名开始时间：",
                        prop: "competition_startdate",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFilter")(
                            _vm.courseContent.competition_startdate,
                            "yyyy-MM-dd HH:mm"
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item",
                      staticStyle: { width: "650px" },
                      attrs: {
                        label: "报名结束时间：",
                        prop: "competition_enddate",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFilter")(
                            _vm.courseContent.competition_enddate,
                            "yyyy-MM-dd HH:mm"
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          margin: "5px 10px",
          "align-items": "center",
        },
      },
      [
        _c("div", { staticClass: "zj-flex-ceter" }, [
          _c("img", {
            staticStyle: {
              width: "25px",
              height: "25px",
              "margin-right": "10px",
            },
            attrs: { src: "/static/base/img/通知.png" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "font-weight": "600", color: "#409EFF" } }, [
          _vm._v("大赛公告"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          margin: "5px 10px",
          "align-items": "center",
        },
      },
      [
        _c("div", { staticClass: "zj-flex-ceter" }, [
          _c("img", {
            staticStyle: {
              width: "25px",
              height: "25px",
              "margin-right": "10px",
            },
            attrs: { src: "/static/base/img/通知.png" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "font-weight": "600", color: "#409EFF" } }, [
          _vm._v("活动公告"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }